import { render, staticRenderFns } from "./ProductsServices.vue?vue&type=template&id=1067b11c&"
import script from "./ProductsServices.vue?vue&type=script&lang=js&"
export * from "./ProductsServices.vue?vue&type=script&lang=js&"
import style0 from "./ProductsServices.vue?vue&type=style&index=0&id=1067b11c&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1067b11c')) {
      api.createRecord('1067b11c', component.options)
    } else {
      api.reload('1067b11c', component.options)
    }
    module.hot.accept("./ProductsServices.vue?vue&type=template&id=1067b11c&", function () {
      api.rerender('1067b11c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ProductsServices.vue"
export default component.exports